import loaderMixin from '@/mixins/loader';
import { mapActions, mapGetters, mapState } from 'vuex';
import collapsiblePanel from '@/components/collapsible-panel/collapsible-panel.vue';
import contractsHistory from '@/components/contracts-history/contracts-history.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';

export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    collapsiblePanel,
    contractsHistory,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapState('market', ['contracts', 'history']),
    ...mapGetters('market', ['getMarketHistoryData']),
    historyContracts() {
      const data = this.getMarketHistoryData;
      return data.slice(0, 4);
    },
  },
  watch: {
    isOpen: {
      handler: 'openWatcher',
      immediate: true,
    },
  },
  methods: {
    ...mapActions('market', ['getMarketHistory', 'resetHistory']),
    ...mapActions('popup', ['setCurrentSmallPopup', 'setCurrentPopupOptions']),
    loadHistory() {
      this.loaderAdd();
      this.getMarketHistory(this.market.marketId)
        .then(() => this.loaderRemove())
        .catch(() => {
          this.loaderRemove();
          this.isLoaded = false;
        });
    },
    onInfoClick() {
      this.setCurrentSmallPopup(MODALS.SMALL_TRADE_INFO);
      this.setCurrentPopupOptions({ completeInfo: true });
    },
    openWatcher(open) {
      if (open && !this.isLoaded) {
        this.resetHistory();
        this.isLoaded = true;
        this.loadHistory();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-history/market-history.js